import { useState } from "react";
import { NavLink } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { LanguageSwitch } from "./LanguageSwitch";
import logo from "../assets/img/logo.png";

export const Header = () => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);

  const navLinkClass = ({ isActive }) => "nav-link" + (isActive ? " active" : "");

  return (
    <header className="site-header">
      <div className="site-header-inner">
        <NavLink to="/" className="brand" onClick={() => setOpen(false)}>
          <img src={logo} alt="Sport with Natalia" />
        </NavLink>

        <button
          className={"nav-toggle" + (open ? " open" : "")}
          aria-label="Menu"
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
        >
          <span />
        </button>

        <nav className={"site-nav" + (open ? " open" : "")}>
          <NavLink to="/" end className={navLinkClass} onClick={() => setOpen(false)}>
            {t.nav.home}
          </NavLink>
          <NavLink to="/ochno" className={navLinkClass} onClick={() => setOpen(false)}>
            {t.nav.ochno}
          </NavLink>
          <NavLink to="/online" className={navLinkClass} onClick={() => setOpen(false)}>
            {t.nav.online}
          </NavLink>
          <NavLink to="/o-trenere" className={navLinkClass} onClick={() => setOpen(false)}>
            {t.nav.about}
          </NavLink>
          <div className="nav-lang-mobile">
            <LanguageSwitch />
          </div>
        </nav>

        <div className="nav-lang-desktop">
          <LanguageSwitch />
        </div>
      </div>
    </header>
  );
};
